export default __webpack_public_path__ + "static/resume-maker-a8cf4fdb74098bf9458c6d352548ac1d.png";